import { Grid,Divider,Box} from '@material-ui/core';
import ActionBar from 'components/ActionBar/ActionBar';
import KeepaLayout from 'components/Layout';
import CardDetail from './Components/CardDetail';
// import Content from './Components/Content';
import Outline from 'components/Button/Outline';
import Contained from 'components/Button/Contained';
import DebtItems from '../Components/DebtItems';
import {SalaryMsg} from "../../Installments/Components/InstallmentsMsg";
import BottomSheet from "../../../components/BottomSheet";
const DetailInstallment = () => {
	const handleGoBack = () => {};
	
	const DATA = [
		{
			id: 1,
			name: 'جانبو',
			pay: 8750000,
			paid: false,
		},
		{
			id: 2,
			name: 'دندان پزشکی مریم',
			pay: 8750000,
			paid: false,
		},
		{
			id: 3,
			name: 'خانه سام',
			pay: 16750000,
			paid: false,
		},
		{
			id: 4,
			name: 'هفت',
			pay: 875000,
			paid: false,
		},
		{
			id: 5,
			name: 'تست',
			pay: 10000000,
			paid: false,
		},

		{
			id: 6,
			name: '1تست',
			pay: 10000000,
			paid: false,
		},
		{
			id: 7,
			name: '2تست',
			pay: 10000000,
			paid: false,
		},

		{
			id: 8,
			name: '3تست',
			pay: 10000000,
			paid: false,
		},
		{
			id: 9,
			name: '4تست',
			pay: 10000000,
			paid: false,
		},
		{
			id: 10,
			name: '5تست',
			pay: 10000000,
			paid: false,
		},
	];
	

	
	return (
			<KeepaLayout
				buttonComponent={
					<Grid container style={{ display: 'flex', justifyContent: 'space-between'}}>
						<Grid xs={5} item>
						<BottomSheet
					style={{ width: '100%', padding: 0, margin: 0 }}
					Component={
						<Box width={'100%'} p={'24px'}>
							<SalaryMsg/>
						</Box>
					}
					button={
						<Outline> کسر از حقوق</Outline>
					}
				/>
						</Grid>
						<Grid xs={6} item>
							<Contained>پرداخت آنلاین</Contained>
						</Grid>
					</Grid>
				}
				disableGutters
				actionBar={
					<ActionBar
						title="جزئیات اقساط"
						arrow="icon-arrowflow-right"
						isDark
						divider
						onClick={handleGoBack}
					/>
				}
			>
				<Grid container>
					<Grid item xs={12} style={{ backgroundColor: '#F1F4F8' }}>
						<Grid container style={{ padding: 0 }}>
							<Grid item xs={12} style={{ padding: '16px 16px 24px 16px' }}>
								<CardDetail />
							</Grid>
						</Grid>
						
				
					</Grid>

				</Grid>
				<Grid container style={{background: "white"}}>
							<Grid xs={12} item>
							{
								DATA.map((item , index) => 
							<>
									<DebtItems debtOptions={DATA} item={item} arrKey={index} key={index}/>	
								{index + 1 <= DATA.length - 1 && (
								<Divider style={{ width: '100%', background: '#E9E9F0', height: 1, margin: '16px 0' }} />
							)}
							</>
								
								)
							}

							</Grid>
							
						</Grid>
			</KeepaLayout>
	);
};

export default DetailInstallment;
